
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kolefnisreiknir",
      function () {
        return require("private-next-pages/kolefnisreiknir.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kolefnisreiknir"])
      });
    }
  